<template>
    <div class="popup-container">
        <button @click="pressed"></button>
        <div class="form">
            <form action="()=>{}" method="post">
                <div class="form-item">
                    <label for="name">Name: </label>
                    <input type="text" name="name" id="name" placeholder="Jon Doe">
                </div>
                <div class="form-item">
                    <label for="phone">Phone Number: </label>
                    <input type="tel" name="phone" id="phone" pattern="[0-9]{8}" placeholder="03123456">
                </div>
                <div class="form-item">
                    <label for="shop">Shop Name</label>
                    <input type="shop" name="shop" id="shop" placeholder="Your Shop/Business name">
                </div>
                <div class="form-item">
                    <label for="location">Location</label>
                    <input type="text" name="location" id="location" placeholder="Beirut">
                </div>
            </form>
            <button><span>Submit</span></button>
            <button @click="pressed"><i class="fas fa-times"></i></button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Partner',
        methods:{
            pressed(){
                this.$emit('partner-pressed')
            }
        },
        emits:['partner-pressed'],

    }
    
</script>

<style scoped>
    .popup-container{
        height: 100vh;
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 100;
        padding: 4rem 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, .6);
    }
    .popup-container> button{
        position: absolute;
        display: inline-block;
        width: 100%;
        height: 100%;
        background: none;
        outline: none;
        border: none;
    }
    .popup-container .form{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: #f1f3f7;
        padding: 10rem 5rem;
        border-radius: 2rem;
    }
    .popup-container .form form{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .popup-container .form form .form-item{
        display: flex;
        width: 50rem;
        align-items: center;
        position: relative;
        margin: 1rem;
    }
    .popup-container .form form label{
        display: inline-block;
        width: 20rem;
        font-size: 2rem;
        text-align: left;
        color: var(--accent);
    }
    .popup-container .form form select{
        display: inline-block;
        width: 20rem;
        text-align: center;

    }
    .popup-container .form form input{
        display: inline-block;
        width: 20rem;
        padding: 1rem 1rem;
        outline: none;
        border: none;
        border-bottom: 1px solid var(--background);
        color: var(--background);
        font-size: 1.5rem;
        align-items: center;
        justify-content: center;
        background: #f1f3f7;
    }
    .popup-container .form  button{
        width: fit-content;
        padding: 1rem 2rem;
        font-size: 2rem;
        border: none;
        outline: none;
        border-radius: 1rem;
        margin-top: 4rem;
        cursor: pointer;
        box-shadow: -2px -2px 8px rgba(255, 255, 255, 1),
                    -2px -2px 12px rgba(255, 255, 255, .5),
                    inset 2px 2px 4px rgba(255, 255, 255, .1),
                    2px 2px 8px rgba(0, 0, 0, .15);
    }
    .popup-container .form button span{
        display: inline-block;
        color: var(--accent);
    }
    .popup-container .form  button:hover{
        box-shadow: inset -2px -2px 8px rgba(255, 255, 255, 1),
                    inset -2px -2px 12px rgba(255, 255, 255, .5),
                    inset 2px 2px 4px rgba(255, 255, 255, .1),
                    inset 2px 2px 8px rgba(0, 0, 0, .15);
    }
    .popup-container .form  button:hover span{
        transform: scale(.98);   
    }
    i{
        color: var(--accent);
    }
    .popup-container .form button:hover i{
        display: inline-block;
        transform: scale(.98);
    }
     @media screen and (max-width:768px) and (min-width:480px){
        .popup-container .form{
            padding: 4rem;
        }
        .popup-container .form form .form-item{
            flex-direction: column;
            align-items: center;
            width: unset;
        }
        .popup-container .form form .form-item label{
            display: inline-block;
        }
    }
    @media screen and (max-width:479px){
        .popup-container .form{
            padding: 2rem;
        }
        .popup-container .form form .form-item{
            flex-direction: column;
            align-items: center;
            width: unset;
        }
        .popup-container .form form .form-item label{
            display: inline-block;
        }
    }

</style>